import { adminClient as apolloClient } from '@/store/apollo';

import EventsWithSlotsGql from '@/extensions/shop/store/graphql/queries/EventsWithSlots.gql';
import EventSlotsPaginatedGql from '@/extensions/shop/store/graphql/queries/EventSlotsPaginated.gql';

export default {
    /**
     * The events a ticket product can be built from. Names only - the dates come from
     * fetchSlotsPaginated, because an event can carry thousands of them.
     */
    fetchEventsWithSlots: (cmsID = null) =>
        new Promise((resolve, reject) => {
            const variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: EventsWithSlotsGql,
                    variables,
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(data.EX_EVNT_Events))
                .catch(err => reject(err));
        }),

    /**
     * One page of an event's dates.
     *
     * @param {Object} options
     * @param {Number} options.eventID   the event to read
     * @param {Number} options.page      1-based
     * @param {Number} options.perPage
     * @param {Boolean} options.upcomingOnly  drop past and canceled dates
     * @param {Number} options.from      unix seconds, inclusive
     * @param {Number} options.to        unix seconds, inclusive
     */
    fetchSlotsPaginated: ({
        eventID,
        page = 1,
        perPage = 10,
        upcomingOnly = true,
        from = null,
        to = null,
        comment = null,
        order = 'start_at',
        direction = 'asc',
    }) =>
        new Promise((resolve, reject) => {
            const filters = [{ key: 'events', in: [parseInt(eventID)] }];

            if (upcomingOnly) filters.push({ key: 'upcoming', match: true });
            if (from || to) filters.push({ key: 'start_at', from, to });
            if (comment) filters.push({ key: 'comment', like: comment });

            apolloClient
                .query({
                    query: EventSlotsPaginatedGql,
                    variables: {
                        currentPage: parseInt(page),
                        perPage: parseInt(perPage),
                        order,
                        direction,
                        filters,
                    },
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(data.EX_EVNT_SlotsPaginated))
                .catch(err => reject(err));
        }),
};
